import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, vShow as _vShow, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "serial-product-content-wrapper" }
const _hoisted_2 = { class: "serial-product-content" }
const _hoisted_3 = { class: "serial-product-intro" }
const _hoisted_4 = { class: "serial-product-title" }
const _hoisted_5 = { class: "serial-product-title" }
const _hoisted_6 = { class: "serial-product-button-icon flex-center" }
const _hoisted_7 = ["src"]

import useAppear from '@/hooks/use-appear'
import { namedImages } from '@/store'
import { isAsciiOrExtended } from '@/utils'
import { isIOS } from '@/utils/device'
import { computed } from 'vue'

// eslint-disable-next-line no-undef

export default /*@__PURE__*/_defineComponent({
  __name: 'SerialProduct',
  props: {
  kv: {
    type: String,
    required: true
  },
  title: {
    type: Array as () => string[][],
    required: true
  }
},
  emits: ['tap'],
  setup(__props, { emit: __emit }) {

const emit = __emit
// eslint-disable-next-line no-undef
const props = __props

const { target, coverVisible } = useAppear()

const titleLine1 = computed(() => {
  return props.title[0].map(text => ({
    text,
    typo: isAsciiOrExtended(text)
      ? 'ABChanelCorpo-2022-Regular font-18'
      : 'PingFangSC-SemiBold font-16'
  }))
})

const titleLine2 = computed(() => {
  return props.title[1].map(text => ({
    text,
    typo: isAsciiOrExtended(text)
      ? 'ABChanelCorpo-2022-Regular font-18'
      : 'PingFangSC-SemiBold font-16'
  }))
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["serial-product", { 'is-ios': _unref(isIOS) }])
  }, [
    _createElementVNode("div", {
      ref_key: "target",
      ref: target,
      class: "serial-product-kv flex-center"
    }, [
      _withDirectives(_createElementVNode("div", {
        class: "serial-product-image",
        style: _normalizeStyle(`background-image: url(${__props.kv})`)
      }, null, 4), [
        [_vShow, _unref(coverVisible)]
      ])
    ], 512),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(titleLine1.value, (t, i) => {
              return (_openBlock(), _createElementBlock("span", {
                key: i,
                class: _normalizeClass(t.typo)
              }, _toDisplayString(t.text), 3))
            }), 128))
          ]),
          _createElementVNode("div", _hoisted_5, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(titleLine2.value, (t, i) => {
              return (_openBlock(), _createElementBlock("span", {
                key: i,
                class: _normalizeClass(t.typo)
              }, _toDisplayString(t.text), 3))
            }), 128))
          ])
        ]),
        _createElementVNode("div", {
          class: "serial-product-button",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('tap')))
        }, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("img", {
              src: _unref(namedImages).icon_try_on_white
            }, null, 8, _hoisted_7)
          ]),
          _cache[1] || (_cache[1] = _createElementVNode("div", { class: "serial-product-button-label PingFangSC-Regular lh-18 font-14" }, " 虚拟体验 ", -1))
        ])
      ])
    ])
  ], 2))
}
}

})